export enum CategoryTypeEnum {
    credito_venda_mercadoria = 'credito_venda_mercadoria',
    credito_prestacao_servico = 'credito_prestacao_servico',
    debito_devolucao_produto_servico = 'debito_devolucao_produto_servico',
    debito_imposto_sobre_vendas = 'debito_imposto_sobre_vendas',
    debito_custo_produto_mercadoria = 'debito_custo_produto_mercadoria',
    debito_investimento = 'debito_investimento',
    debito_custo_servico = 'debito_custo_servico',
    debito_despesa_administrativa = 'debito_despesa_administrativa',
    debito_despesa_operacional = 'debito_despesa_operacional',
    debito_despesa_financeira = 'debito_despesa_financeira',
    credito_receita_financeira = 'credito_receita_financeira',
    debito_despesa_nao_operacional = 'debito_despesa_nao_operacional',
    credito_receita_nao_operacional = 'credito_receita_nao_operacional',
    debito_imposto_renda = 'debito_imposto_renda',
    debito_csll = 'debito_csll',
    credito_recebimento_emprestimo_aporte = 'credito_recebimento_emprestimo_aporte',
    debito_pagamento_emprestimo_aporte = 'debito_pagamento_emprestimo_aporte',
    debito_distribuicao_lucro = 'debito_distribuicao_lucro',
    credito_a_desconsiderar = 'credito_a_desconsiderar',
    debito_a_desconsiderar = 'debito_a_desconsiderar',
    credito_investimento = 'credito_investimento',
}

export enum CategoryTypeFriendlyEnum {
    credito_venda_mercadoria = 'Crédito - Venda de mercadoria',
    credito_prestacao_servico = 'Crédito - Prestação de serviço',
    debito_devolucao_produto_servico = 'Débito - Devolução de produto ou serviço',
    debito_imposto_sobre_vendas = 'Débito - Imposto sobre vendas',
    debito_custo_produto_mercadoria = 'Débito - Custo do produto ou mercadoria',
    debito_investimento = 'Débito - Investimentos',
    debito_custo_servico = 'Débito - Custo do serviço',
    debito_despesa_administrativa = 'Débito - Despesa administrativa',
    debito_despesa_operacional = 'Débito - Despesa operacional',
    debito_despesa_financeira = 'Débito - Despesa financeira',
    credito_receita_financeira = 'Crédito - Receita financeira',
    debito_despesa_nao_operacional = 'Débito - Despesa não operacional',
    credito_receita_nao_operacional = 'Crédito - Receita não operacional',
    debito_imposto_renda = 'Débito - Imposto de renda',
    debito_csll = 'Débito - Imposto CSLL',
    credito_recebimento_emprestimo_aporte = 'Crédito - Recebimento de empréstimo ou aporte',
    debito_pagamento_emprestimo_aporte = 'Débito - Pagamento de empréstimo ou aporte',
    debito_distribuicao_lucro = 'Débito - Distribuição de lucros',
    credito_a_desconsiderar = 'Crédito - A desconsiderar',
    debito_a_desconsiderar = 'Débito - A desconsiderar',
    credito_investimento = 'Crédito - Investimentos',
}
